import { Box, Text } from '@factorialco/deprecated-design-system'

import Rating from 'modules/core/components/Rating'

import { RatingAnswerProps } from 'modules/form_answers/lib/types'

export const RatingAnswer: React.FC<RatingAnswerProps> = ({ ratingLabels, question, answer }) => {
  const max = question.materializedQuestionOptions?.length || 5
  const ratingLabel = answer ? ratingLabels[answer] : ''

  return (
    <Box gap="s8">
      <Rating
        aria-labelledby={question.id}
        hasTooltip
        min={1}
        max={max}
        mandatory={question.mandatory}
        value={answer || null}
        readonly
      />
      <Text.Normal size="200" weight="medium" color="grey800">
        {ratingLabel}
      </Text.Normal>
    </Box>
  )
}
